import { useEffect } from 'react';
import { Outlet, useLocation, useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import styles from './viewSettlement.module.css';
import { useBreadcrumbs } from '../../../components/ui/breadcrumps/breadcrumbsContext';
import { useCRUD } from '../../../api/crud';
import { SETTLEMENTS_ENDPOINT } from '../../../consts';
import { getSettlementDisplayLabel } from '../../../utils/settlementContractTerms';

export const ViewSettlement = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const { id } = useParams();
  const { setOverride } = useBreadcrumbs();
  const { get } = useCRUD(SETTLEMENTS_ENDPOINT);

  // Fetch settlement data for breadcrumb override
  useEffect(() => {
    const fetchSettlement = async () => {
      if (id) {
        const response = await get(id);
        if (response.data) {
          const equipmentLabel = getSettlementDisplayLabel(response.data, t, id);
          const displayName = response.data.sale_date
            ? `${equipmentLabel} - ${response.data.sale_date}`
            : equipmentLabel;
          setOverride(`/settlements/${id}`, displayName);
        }
      }
    };
    fetchSettlement();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  // Extract settlement ID from pathname
  const pathname = location.pathname;
  const settlementIdMatch = pathname.match(/\/settlements\/([^/]+)/);
  const settlementId = settlementIdMatch ? settlementIdMatch[1] : null;
  const basePath = settlementId ? `/settlements/${settlementId}` : '/settlements';

  const visibleTabs = [
    { key: 'basic', path: basePath },
    { key: 'positions', path: `${basePath}/positions` },
    { key: 'extraPositions', path: `${basePath}/extra-positions` },
  ];

  const getTabValue = () => {
    if (pathname.includes('/positions')) {
      const index = visibleTabs.findIndex(tab => tab.key === 'positions');
      return index >= 0 ? index : 0;
    }
    if (pathname.includes('/extra-positions')) {
      const index = visibleTabs.findIndex(tab => tab.key === 'extraPositions');
      return index >= 0 ? index : 0;
    }
    return 0;
  };

  return (
    <Box className={styles.container}>
      <Tabs
        value={getTabValue()}
        variant="scrollable"
        scrollButtons="auto"
      >
        {visibleTabs.map((tab) => {
          const labels: Record<string, string> = {
            basic: t("Basic Information"),
            positions: t("Positions"),
            extraPositions: t("Extra positions"),
          };
          return (
            <Tab
              key={tab.key}
              label={labels[tab.key]}
              onClick={() => navigate(tab.path)}
            />
          );
        })}
      </Tabs>
      <Box className={styles.content}>
        <Outlet />
      </Box>
    </Box>
  );
};
